import { useCallback } from "react";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/wonder/SmoothScroll";
import NoiseOverlay from "@/components/wonder/NoiseOverlay";
import Nav from "@/components/wonder/Nav";
import Hero from "@/components/wonder/Hero";
import VideoBlock from "@/components/wonder/VideoBlock";
import Manifesto from "@/components/wonder/Manifesto";
import Pricing from "@/components/wonder/Pricing";
import FAQ from "@/components/wonder/FAQ";
import StickyCTA from "@/components/wonder/StickyCTA";
import Footer from "@/components/wonder/Footer";
import { PAYMENT_URL } from "@/lib/config";

export default function WonderTime() {
  const handleBuyNow = useCallback(() => {
    window.location.href = PAYMENT_URL;
  }, []);

  return (
    <div className="relative bg-cream text-ink min-h-screen" data-testid="wonder-page">
      <SmoothScroll />
      <NoiseOverlay />
      <Toaster position="top-center" richColors closeButton />
      <Nav />
      <main>
        <Hero onBuyNow={handleBuyNow} />
        <VideoBlock />
        <Manifesto />
        <Pricing onBuyNow={handleBuyNow} />
        <FAQ />
      </main>
      <Footer />
      <StickyCTA onBuyNow={handleBuyNow} />
    </div>
  );
}
